export const toQuestionType = {
  multi: 'Multiple Choice',
  select: 'Selection Box',
  code: 'Code',
  open: 'Open Question',
};
